/** Retired Paper drafts contain customer names/ink and share the session privacy fence. */
export function clearPaperDrafts(): boolean {
  try {
    for (const key of Object.keys(localStorage)) if (key.startsWith('paper-draft:')) localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}
